module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticStyle: {
      "border": "dashed 3px #ccc",
      "color": "#bbb",
      "padding": "10px",
      "border-radius": "8px"
    }
  }, [_vm._v("\n        New Component\n    ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-720dac24"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/builder/Template.vue
// module id = 2599
// module chunks = 1